export const getEmailFromUrl = (url) => {
  if (!url.includes('email')) return null;
  const params = url
    .split('?')[1]
    .split('&')
    .reduce((allParams, param) => {
      const [key, value] = param.split('=');
      if (!key || !value) return allParams;
      return {
        ...allParams,
        [key]: value,
      };
    }, {});
  if (!params?.email) return null;
  return decodeURIComponent(params.email);
};

export const cleanReturnUrl = (url) => url.split('?')[0];

export const extractIdFromUrl = (url) => {
  const parts = url.split('/');
  const idx = parts.indexOf('job');
  if (idx === -1) return null;
  const param = parts?.[idx + 1];
  if (!param) return null;
  return param.split('?')[0];
};
